import React from 'react';
import './Card.css';
import inverted from '../../../images/Testimonial Images/inverted.svg';

const Card = ({ testimonialText, imgSrc, doctorName }) => {
  return (
    <div className="card">
      <div className="svg">
        <img src={inverted} width="50px" height="50px" alt="inverted" />
      </div>
      <div className="Card-name">
        <h4 className="doctor-name">{doctorName}</h4>
      </div>
      <div className="text">
        {testimonialText}
      </div>
      <div className="hr"></div>
      <div className="card-img">
        <img src={imgSrc} alt="testimonial" width="90px" height="90px" />
      </div>
    </div>
  );
};

export default Card;